const customAlertBarTheme = {
  customAlertBarTheme: {
    alignItems: 'center',
    padding: '10px 16px 10px 18px',
    gap: '16px',
    mobile: { borderRadius: '0' },
    tablet: { borderRadius: '0' },
    desktop: { borderRadius: '0' },
  },
};

export default customAlertBarTheme;
